<div class="container-fluid">
  <app-content-tab-list activeTab="0" type="ecommerce" category="E-commerce"></app-content-tab-list>

  <div class="row section1 justify-content-between mt-4 ecom-page-header">
    <div class="col-12 col-md-auto">
      <div class="home-details">
        <h5 class="home-title">Categories ({{categories.length}})</h5>
        <p class="home-subtitle">Organize products shown in Marketplace collections</p>
      </div>
    </div>
    <div class="col-12 col-md-auto">
      <button type="button" class="btn btn-primary btn-dashboard" (click)="open()">
        <i class="las la-plus"></i>Add Category
      </button>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="table-responsive applicants-details overflow-x-visible">
        <table class="table table-bordered user-table">
          <thead>
            <tr>
              <th>Icon</th>
              <th>Category</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          @if (!loading && categories.length) {
            <tbody>
              @for (item of categories; track item._id) {
                <tr>
                  <td><img class="ecom-icon" [src]="item.iconUrl || 'assets/images/placeholder.png'" onerror="this.src='assets/images/placeholder.png'" alt=""></td>
                  <td>
                    <div class="ecom-item-title">{{item.title}}</div>
                    <div class="ecom-item-subtitle ecom-description">{{item.description || 'No description'}}</div>
                  </td>
                  <td><span class="ecom-status" [ngClass]="item.isActive === false ? 'archived' : item.status">{{item.isActive === false ? 'Inactive' : item.status}}</span></td>
                  <td class="action">
                    <div class="dropdown ecom-action-menu">
                      <button type="button" class="btn btn-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="text-primary text-nowrap">View actions <i class="las la-angle-down align-middle"></i></span>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right py-0">
                        <button type="button" class="dropdown-item text-info border-bottom py-2" (click)="open(item)"><i class="las la-edit la-lg align-middle"></i> Edit</button>
                        <button type="button" class="dropdown-item border-bottom py-2" (click)="toggleActive(item)">
                          <i class="las la-power-off la-lg align-middle"></i> {{item.isActive === false ? 'Activate' : 'Deactivate'}}
                        </button>
                        <button type="button" class="dropdown-item text-danger py-2" (click)="remove(item)"><i class="las la-trash-alt la-lg align-middle"></i> Delete</button>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>
      @if (!loading && !categories.length) { <div class="ecom-empty">No categories added yet</div> }
    </div>
  </div>
</div>

@if (showModal) {
  <div class="modal fade show ecom-modal" tabindex="-1" role="dialog" (click)="close()">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{editId ? 'Edit' : 'Add'}} Category</h5>
          <button type="button" class="close" aria-label="Close" (click)="close()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <label class="ecom-label" for="category-title">Title <span class="required">*</span></label>
              <input id="category-title" class="form-control" [(ngModel)]="form.title" placeholder="Enter category title">
            </div>
            <div class="col-12 col-md-6 mt-3">
              <label class="ecom-label" for="category-slug">Slug (optional)</label>
              <input id="category-slug" class="form-control" [(ngModel)]="form.slug" placeholder="Generated from title">
            </div>
            <div class="col-12 col-md-6 mt-3">
              <label class="ecom-label" for="category-status">Status</label>
              <select id="category-status" class="form-control" [(ngModel)]="form.status">
                <option value="draft">Draft</option><option value="published">Published</option><option value="archived">Archived</option>
              </select>
            </div>
            <div class="col-12 mt-3">
              <label class="ecom-label" for="category-description">Description</label>
              <textarea id="category-description" class="form-control" rows="4" [(ngModel)]="form.description" placeholder="Describe this collection"></textarea>
            </div>
            <div class="col-12 mt-3">
              <span class="ecom-label">Upload icon</span>
              <label class="ecom-upload" for="category-icon-upload">
                <img class="ecom-upload-preview" [src]="form.iconUrl || 'assets/images/placeholder.png'" onerror="this.src='assets/images/placeholder.png'" alt="Icon preview">
                <span class="ecom-upload-copy"><strong>{{form.iconUrl ? 'Change icon' : 'Choose icon'}}</strong>PNG, JPG or WebP</span>
              </label>
              <input id="category-icon-upload" type="file" accept="image/*" class="d-none" (change)="uploadIcon($event)">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="close()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="saving" (click)="save()">{{saving ? 'Saving...' : (editId ? 'Save Changes' : 'Add Category')}}</button>
        </div>
      </div>
    </div>
  </div>
}

@if (showIconCropModal) {
  <div class="modal fade show ecom-modal ecom-crop-modal" tabindex="-1" role="dialog" (click)="closeIconCropModal()">
    <div class="modal-dialog modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <div><h5 class="modal-title">Crop category icon</h5><small class="text-muted">Square crop</small></div>
          <button type="button" class="close" aria-label="Close" [disabled]="uploading" (click)="closeIconCropModal()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body ecom-crop-body">
          <image-cropper
            [imageFile]="iconImageFile"
            [maintainAspectRatio]="true"
            [aspectRatio]="iconAspectRatio"
            format="png"
            [imageQuality]="100"
            [resizeToWidth]="512"
            (imageCropped)="onIconImageCropped($event)"
            (loadImageFailed)="onIconImageLoadFailed()"></image-cropper>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" [disabled]="uploading" (click)="closeIconCropModal()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="uploading || !croppedIconFile" (click)="uploadCroppedIcon()">{{uploading ? 'Uploading...' : 'Crop & Upload'}}</button>
        </div>
      </div>
    </div>
  </div>
}
